import React, { useCallback } from 'react';
import './imageView.css';
import { Button, Modal } from 'react-bootstrap';
import ImageItem from './../../components/ImageItem/imageItem';
import { Grid, TextField } from '@material-ui/core';
import { Item } from 'semantic-ui-react';
import MaskedInput from 'components/maskTextInput';
import useImageData from '../../pages/cloud-invoice-ui/hooks';

interface EditI {
  row: any;
  setMount:(f: boolean) => void;
  depData: any[];
  rowReset: (s: any) => void;
  editopen: boolean;
  setEditOpen: (e: boolean) => void;
}
const Edit: React.FC<EditI> = ({
  depData,
  row,
  editopen,
  setEditOpen,
  setMount,
  rowReset,
}) => {
  const [display, setDisplay] = React.useState<boolean>(false);
  const [dataisset, setdataisset] = React.useState<boolean>(false);
  const [rowData, setRowdata] = React.useState<any>([]);
  const [valuErrors, setvaluErrors] = React.useState<any>([]);
  const { updateOcr } = useImageData();
  const handlesubmit = async (invRno, data, statuscode) => {
    await updateOcr(invRno, data, statuscode);
    displayClose();
     setMount(false)
    // Additional logic after deletion if needed
  };
  const handleView = id => {
    setDisplay(false);
  };

  const handleChange = (data, value) => {
    rowData[0][data] = value;
    setRowdata([...rowData]);
    checkError(rowData[0]);
  };

  const displayClose = () => {
    setEditOpen(false);
    setDisplay(false);
    setdataisset(false);
    rowReset([]);
  
  };

  const handleOpen = useCallback(() => {
    setDisplay(true);

  }, []);

  const checkError = useCallback(data => {
    let Tot = parseFloat(data.total).toFixed(2);
    let SubTot = parseFloat(data.subtotal).toFixed(2);
    let Vat = parseFloat(data.tax).toFixed(2);
   
    let errorDat = [];

    Tot < SubTot  ? errorDat.push('sub_total', 'total')   : errorDat.filter( element => element !== 'sub_total' && element !== 'total');

          Tot < Vat ? errorDat.push('vat', 'total')     : errorDat.filter(element => element !== 'vat' && element !== 'vat');
         
    SubTot < Vat
      ? errorDat.push('sub_total', 'vat')
      : errorDat.filter(
          element => element !== 'sub_total' && element !== 'vat',
        );
        
        (parseFloat(SubTot) + parseFloat(Vat)).toFixed(2) !== Tot
      ? errorDat.push('sub_total', 'vat', 'total')
      : errorDat.filter(
          element =>
            element !== 'sub_total' && element !== 'vat' && element !== 'total',
        );
   
    setvaluErrors([...errorDat]);
  }, []);

  React.useEffect(() => {
   
    if (editopen) {
      handleOpen();
      if (!dataisset) {
        checkError(row);
        console.log(row.inv_status!=="")
        setRowdata([row]);

        setdataisset(true);
      }
    }
  }, [checkError, dataisset, editopen, handleOpen, row, rowData]);

  return (
    <div>
      {display && (
        <>
          <Modal
            size="xl"
            className="mw-50 h-150"
            show={true}
            cancel={displayClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            animation={true}>
            <Modal.Header>
              <div>
                <div style={{ marginBottom: '5px !important' }}>
                  <Modal.Title
                    style={{
                      marginBottom: '5px !important',
                      marginLeft: '15px',
                    }}
                    id="contained-modal-title-vcenter">
                    Uploaded Images
                    <br />
                    <span style={{ fontStyle: 'bold' }}>
                      <h4>{row.date}</h4>
                    </span>
                  </Modal.Title>
                  <div></div>
                </div>
              </div>
              <div className="d-flex">
                <div>
                  <Button
                    className="m-1"
                    variant="secondary"
                    onClick={displayClose}
                    size="sm">
                    Cancel
                  </Button>
                </div>
                <div></div>
              </div>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {Object.keys(row).length > 0 && (
                <div style={{ display: 'flex' }}>
                  <div style={{ margin: '2px' }}>
                    {row.imageUri.map(ep => (
                      <ImageItem
                        key={ep.rno}
                        image={ep}
                        url={ep.temp_url}
                        onView={handleView}
                      />
                    ))}
                  </div>
                </div>
              )}
            </Modal.Body>

            <Grid xs={12} style={{ paddingBottom: '15px', paddingTop: '15px' }}>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  width: '200px',
                  padding: '10px',
                  marginLeft: '15px',
                }}>
                <Item>
                  <h3 style={{ width: 'max-content' }}>OCR Image Details</h3>
                </Item>
              </Grid>

              <Grid
                item
                xs={5}
                xl={12}
                md={12}
                lg={12}
                style={{
                  display: 'flex',
                  marginLeft: '10px',
                  marginBottom: '10px',
                }}>
                <Item style={{ marginLeft: '15px' }}>
                  <label>Supplier</label>
                  <TextField
                    id={'tst'}
                    disabled
                    value={row.vendorName}
                    variant="outlined" // Add an outline style
                    style={{
                     width:window.innerWidth>1136?"400px":"280px"
                    }}
                    InputProps={{
                      style: {
                        height: '37px',
                        fontSize: '12.5px',
                      },
                    }}
                  />
                </Item>
                <Item style={{ marginLeft: '15px' }}>
                  <label>Inovoice To</label>
                  <TextField
                    id={'tst2'}
                    disabled
                    value={row.jsonData ? row.jsonData.RECEIVER_ADDRESS : ''}
                    variant="outlined" // Add an outline style
                    style={{
                     width:window.innerWidth>1136?"400px":"280px"
                    }}
                    InputProps={{
                      style: {
                        height: '37px',
                        fontSize: '12.5px',
                      },
                    }}
                  />
                </Item>
              </Grid>

              <Grid
                item
                xs={5}
                xl={12}
                md={12}
                lg={12}
                style={{
                  display: 'flex',
                  marginLeft: '10px',
                  marginBottom: '10px',
                }}>
                <Item style={{ marginLeft: '15px', display: 'grid' }}>
                  <label>Invoice Date</label>
                  <TextField
                    id={'tst3'}
                    disabled
                    value={row.date}
                    variant="outlined" // Add an outline style
                    style={{
                      width:window.innerWidth>1136?"400px":"280px"
                    }}
                    InputProps={{
                      style: {
                        height: '37px',
                        fontSize: '12.5px',
                      },
                    }}
                  />
                </Item>

                <Item style={{ marginLeft: '5%', display: 'grid' }}>
                  <label
                    style={{
                      color: valuErrors.includes('vat') ? 'red' : null,
                    }}>
                    Vat Amount
                  </label>
                  <MaskedInput
                    disabled={row.inv_status==="1"?true:false}
                    error={valuErrors.includes('vat')}
                    onChange={value => handleChange('tax', value)}
                    style={{
                      float: 'none',
                      //minWidth: window.innerWidth>780?"400px":"200px"
                    }}
                    label="Web Price"
                    width={window.innerWidth>1136?"400px":"280px"}
                    value={rowData[0].tax}
                    separator="."
                    name={''}
                  />
                </Item>
              </Grid>
              <Grid
                item
                xs={5}
                xl={12}
                md={12}
                lg={12}
                style={{
                  display: 'flex',
                  marginLeft: '10px',
                  marginBottom: '10px',
                }}>
                <Item style={{ marginLeft: '15px', display: 'grid' }}>
                  <label
                    style={{
                      color: valuErrors.includes('total') ? 'red' : null,
                    }}>
                    Total
                  </label>
                  <MaskedInput
                    disabled={row.inv_status==="1"?true:false}
                    error={valuErrors.includes('total')}
                    onChange={value => handleChange('total', value)}
                    style={{
                      float: 'none',
                      //minWidth: '400px',
                    }}
                    width={window.innerWidth>1136?"400px":"280px"}
                    label="Web Price"
                    value={rowData[0].total}
                    separator="."
                    name={''}
                  />
                </Item>

                <Item style={{ marginLeft: '5%', display: 'grid' }}>
                  <label
                    style={{
                      color: valuErrors.includes('sub_total') ? 'red' : null,
                    }}>
                    Sub Total
                  </label>

                  <MaskedInput
                    disabled={row.inv_status==="1"?true:false}
                    error={valuErrors.includes('sub_total')}
                    onChange={value => handleChange('subtotal', value)}
                    style={{
                      float: 'none',
                     // minWidth: '400px',
                    }}
                    width={window.innerWidth>1136?"400px":"280px"}
                    label="Web Price"
                    value={rowData[0].subtotal}
                    separator="."
                    name={''}
                  />
                </Item>
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display: 'flex',
                  margin: '10px',
                  flexDirection: 'row-reverse',
                  marginTop: '20px',
                  marginRight: '5%',
                }}>
                <button
                  id={'tst'}
                  onClick={() => handlesubmit(row.summary_id, rowData, 1)}
                  style={{
                    width: '180px',
                    marginLeft: '5px',
                    minHeight: '33px',
                    borderRadius: '4px',
                    backgroundColor: 'rgb(4, 190, 91)',
                    color: 'white',
                    fontSize: '12.5px',
                  }}>
                  Accept
                </button>

                <button
                  id={'tst'}
                  onClick={() => handlesubmit(row.summary_id, rowData, 2)}
                  style={{
                    width: '180px',
                    marginRight: '5px',
                    minHeight: '33px',
                    borderRadius: '4px',
                    backgroundColor: 'rgb(208, 33, 28)',
                    color: 'white',
                    fontSize: '12.5px',
                  }}>
                  Reject
                </button>
              </Grid>
            </Grid>
            
          </Modal>
        </>
      )}
    </div>
  );
};

export default Edit;
